import { User } from 'auth/user';
import styles from 'components/ApplicationContainer/application-container.module.scss';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'redux/applicationState';
import {
  fetchApplicationsAction,
  fetchDatabaseServersAction,
} from 'redux/services/referenceDataServices';

export const ApplicationContainer = (props: React.PropsWithChildren): React.ReactElement => {
  const dispatch = useDispatch<any>();
  const currentRightsUser: User = useSelector((state: ApplicationState) => state.currentUser.user);
  const canViewUsers = React.useMemo(
    (): boolean => currentRightsUser.hasAnyRight('VIEW_USERS'),
    [currentRightsUser]
  );

  useEffect((): VoidFunction => {
    const cancels = [dispatch(fetchDatabaseServersAction())];
    if (canViewUsers) {
      cancels.push(dispatch(fetchApplicationsAction()));
    }

    return (): void => {
      cancels.forEach((cancellable: VoidFunction): void => cancellable());
    };
  }, [dispatch, canViewUsers]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
};
